"use client";

import {useTranslation} from "react-i18next";
import VoiceCard from "./VoiceCard";

type VoiceCatalogStatusProps = {
  isLoading: boolean;
  failed: boolean;
  isEmpty: boolean;
  onRetry: () => void;
};

/** Loading, load-failed, and empty states of a voice catalog; null once there are voices to show. */
export default function VoiceCatalogStatus({
  isLoading,
  failed,
  isEmpty,
  onRetry,
}: Readonly<VoiceCatalogStatusProps>) {
  const {t} = useTranslation("inbound");
  const {t: ct} = useTranslation("common");

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {Array.from({length: 4}, (_, i) => (
          <VoiceCard key={i} loading />
        ))}
      </div>
    );
  }

  if (failed) {
    return (
      <div className="bg-destructive/5 p-4 border border-destructive/40 rounded-2xl text-destructive text-sm space-y-2">
        <p>{t("pages.agent.failedLoadingVoices")}</p>
        <button
          type="button"
          onClick={onRetry}
          className="text-sm font-medium text-primary hover:underline cursor-pointer"
        >
          {ct("tryAgain")}
        </button>
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className="bg-muted/30 p-6 border border-border/70 rounded-2xl text-muted-foreground text-sm text-center">
        {t("pages.agent.noVoicesFound")}
      </div>
    );
  }

  return null;
}
